// ============================================
// REQUEST TRACKER — F52-D
// Intercepta XMLHttpRequest + fetch a nivel global
// para rastrear requests en vuelo hacia /api/
// ============================================
// Se importa en main.jsx para activarse antes que
// cualquier service haga requests. No requiere
// modificar ninguno de los 31 service files.
// ============================================

let activeCount = 0;
const listeners = new Set();

function notify() {
  const count = activeCount;
  listeners.forEach(fn => {
    try { fn(count); } catch (e) { /* listener error no debe romper tracking */ }
  });
}

// ============================================
// PATCH 1: XMLHttpRequest (usado por axios)
// ============================================
const origOpen = XMLHttpRequest.prototype.open;
const origSend = XMLHttpRequest.prototype.send;

XMLHttpRequest.prototype.open = function (method, url, ...rest) {
  // Guardar URL para filtrar en send()
  this._rtUrl = typeof url === 'string' ? url : '';
  this._rtMethod = method;
  return origOpen.call(this, method, url, ...rest);
};

XMLHttpRequest.prototype.send = function (...args) {
  // Solo rastrear requests a nuestra API
  if (this._rtUrl.includes('/api/')) {
    activeCount++;
    notify();
    this.addEventListener('loadend', () => {
      activeCount = Math.max(0, activeCount - 1);
      notify();
    }, { once: true });
  }
  return origSend.call(this, ...args);
};

// ============================================
// PATCH 2: fetch (usado por authFetch en OT, lifecycle)
// ============================================
const origFetch = window.fetch;
window.fetch = function (input, ...args) {
  const url = typeof input === 'string' ? input : input?.url || '';
  if (url.includes('/api/')) {
    activeCount++;
    notify();
    return origFetch.call(this, input, ...args).finally(() => {
      activeCount = Math.max(0, activeCount - 1);
      notify();
    });
  }
  return origFetch.call(this, input, ...args);
};

// ============================================
// API PÚBLICA
// ============================================

/**
 * Suscribirse a cambios en el contador de requests activos.
 * @param {Function} fn - Callback recibe (activeCount: number)
 * @returns {Function} unsubscribe
 */
export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

/**
 * Obtener cantidad actual de requests en vuelo.
 */
export function getActiveCount() {
  return activeCount;
}